import React, { useContext } from "react";

export const UrlSlugContext = React.createContext({});

export const UrlSlugProvider = UrlSlugContext.Provider;

export interface UrlSlugContextType {
  urlSlug?: string;
  baseUrl?: string;
  queryString?: string;
}

const useUrlSlugContext = (): UrlSlugContextType => useContext<UrlSlugContextType>(UrlSlugContext);

export default useUrlSlugContext;
